import React from "react";
import { Input } from "antd";
import type { InputProps, InputRef } from "antd";
import useLPDraft from "../useLPDraft";

export type LPInputProps = Omit<InputProps, "value" | "defaultValue"> & { value?: string };

const LPInput = React.memo(
  React.forwardRef<InputRef, LPInputProps>(function LPInput({ value, onChange, onBlur, onPressEnter, ...rest }, ref) {
    const { draft, change, commit } = useLPDraft(value ?? "");
    const inputRef = React.useRef<InputRef>(null);
    const changeEventRef = React.useRef<React.ChangeEvent<HTMLInputElement>>();

    React.useImperativeHandle(ref, () => inputRef.current!);

    return (
      <Input
        {...rest}
        ref={inputRef}
        value={draft}
        onChange={(event) => {
          changeEventRef.current = event;
          change(event.target.value);
        }}
        onBlur={(event) => {
          commit(() => {
            if (changeEventRef.current) {
              onChange?.(changeEventRef.current);
            }
          });
          changeEventRef.current = undefined;
          onBlur?.(event);
        }}
        onPressEnter={(event) => {
          onPressEnter?.(event);
          if (!event.defaultPrevented && !event.nativeEvent.isComposing) {
            event.preventDefault();
            inputRef.current?.blur();
          }
        }}
      />
    );
  }),
);

export default LPInput;
